import router from './router'
import app from './store/app'
import {getCookie, getToken, setCookie, setToken, setUser} from './utils/auth'
import API from './api'

// import VueRouter from 'vue-router'

router.beforeEach(async (to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }

    let token = getToken()
    const white = ['Login', 'Apply', 'Apply1', 'Auth']
    if (!token && white.indexOf(to.name) === -1) {
        next({
            path: '/login'
        })
        // next();
        //普通登录

        //微信授权登录
        // let code = app.mutations.getUrl('code')
        // if (code) {
        //     API.getThird({
        //         'type': 0,
        //         'platform': 'wechat',
        //         'code': code
        //     }).then(res => {
        //         return res;
        //     }).then((res) => {
        //         setUser(JSON.stringify(res.data.userinfo))
        //         setToken(res.data.userinfo.token)
        //         let cache_url = getCookie('cache_url')
        //         if (cache_url) {
        //             next(cache_url)
        //         } else {
        //             next();
        //         }
        //     })
        // } else {
        //     setCookie('cache_url', location.pathname + location.search)
        //     if (to.path !== '/auth') {
        //         console.log(to.path)
        //         next({
        //             path: '/auth'
        //         })
        //     } else {
        //         console.log(222)
        //         next()
        //     }
        // }
    } else {
        next()
    }
})
